// extracted by mini-css-extract-plugin
module.exports = {"main_div":"FeedBack_main_div__O62iE","rating_div":"FeedBack_rating_div__1C8pm","modal_body":"FeedBack_modal_body__3vT8Q","submit_button":"FeedBack_submit_button__2w5hT"};